document.addEventListener('DOMContentLoaded', () => {
  const lookModal = document.querySelector('.product-look-modal');
  const lookModalContent = lookModal.querySelector('.product-look-modal__content .template');
  const lookModalOverlay = lookModal.querySelector('.product-look-modal__overlay');
  const lookModalBackBtn = lookModal.querySelector('.product-look-modal__backbtn');

  const outfitItems = document.querySelectorAll('.product-outfit__item');
  const productDetails = document.querySelectorAll('.product-outfit__info .product-detail__info');

  outfitItems.forEach(item => {
    item.addEventListener('click',(e) => {
      e.preventDefault();
      outfitItems.forEach(rmItem => {
        rmItem.classList.remove('active');
      });

      item.classList.add('active');
    });
  });

  productDetails.forEach(detail => {
    detail.addEventListener('click', (e) => {
      e.preventDefault();

      const handle = detail.getAttribute('data-product-handle');
      if (handle) {
        fetch(`/products/${handle}?view=look`)
        .then(res => res.text())
        .then(html => {
          const newEl = document.createElement('div');
          newEl.innerHTML = html;
          const content = newEl.querySelector('.product.alternate');
          lookModalContent.innerHTML = content.innerHTML;

          if (lookModal) {
            document.body.style.overflow = 'hidden';
            lookModal.classList.add('active');
          }

          renderCarousel();

          setTimeout(() => {
            initVariants();
          }, 100);
        });
      }
    });
  });

  if (lookModalOverlay) {
    lookModalOverlay.addEventListener('click', (e) => {
      lookModal.classList.remove('active');
      document.body.style.overflow = 'auto';
    })
  }

  if (lookModalBackBtn) {
    lookModalBackBtn.addEventListener('click', (e) => {
      e.preventDefault();

      lookModal.classList.remove('active');
      document.body.style.overflow = 'auto';
    })
  }

  function renderCarousel() {
    var slickOpts = {
      slidesToShow: 1,
      slidesToScroll: 1,
      //centerMode: true,
      speed: 700,
      dots: true,
      arrows: false,
    };
    // Init slick carousel
    $('.product-look-modal #carousel').slick(slickOpts);
  }

  function initVariants() {
    const productContainer = lookModalContent;
    if (productContainer && typeof theme.Product === 'function') {
      
      new theme.Product(productContainer);
    }
  }
});